import React, { useEffect } from 'react';
import T from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { useRoute } from '@react-navigation/native';

import { PAYMENT_FLOW_TYPE_FLEX_DRAFT } from '@dmi/shared/redux/Payments/FlexDraft/constants';
import {
  selectConfirmationDictionary,
  selectForm,
  selectInfosectionDictionary,
} from '@dmi/shared/redux/Payments/FlexDraft/selectors';
import { getMainClientInfo, selectIsMurabahaAccount } from '@dmi/shared/redux/Main/selectors';
import { resetConfirmation, setIsModalOpen } from '@dmi/shared/redux/Payments/FlexDraft/actions';

import { StyledScrollView } from '../../../components/base_ui';
import ConfirmationScreen from '../../../components/Payments/Confirmation';

const Confirmation = ({
  confirmationDictionary,
  customerServicePhoneNumber,
  dispatchResetConfirmation,
  dispatchSetIsModalOpen,
  infoSectionDictionary,
  isMurabahaAccount,
  navigation,
}) => {
  const route = useRoute();
  const { confirmationData, draftSchedule } = route.params;
  const infoSectionData = infoSectionDictionary[draftSchedule];

  useEffect(() => () => {
    dispatchResetConfirmation();
  }, [dispatchResetConfirmation]);

  const cancelFlexDraftModalProps = {
    handleCloseModal: () => {},
    handleOnPress: () => {},
    isOpen: false,
    label: 'Label placeholder',
    text: 'Text placeholder',
    title: 'Title placeholder',
  };
  return (
    <StyledScrollView>
      <ConfirmationScreen
        confirmationDictionary={{
          ...confirmationDictionary,
          successLinkLabel: '',
        }}
        customerServicePhoneNumber={customerServicePhoneNumber}
        data={confirmationData}
        dispatchSetIsModalOpen={dispatchSetIsModalOpen}
        flexDraftErrorHeader={confirmationDictionary.errorHeader}
        infoSectionData={infoSectionData}
        isMurabahaAccount={isMurabahaAccount}
        modalProps={cancelFlexDraftModalProps}
        navigation={navigation}
        paymentFlowType={PAYMENT_FLOW_TYPE_FLEX_DRAFT}
      />
    </StyledScrollView>
  );
};

Confirmation.propTypes = {
  confirmationDictionary: T.object.isRequired,
  customerServicePhoneNumber: T.string.isRequired,
  dispatchResetConfirmation: T.func.isRequired,
  dispatchSetIsModalOpen: T.func.isRequired,
  infoSectionDictionary: T.object.isRequired,
  isMurabahaAccount: T.bool.isRequired,
  navigation: T.object.isRequired,
};

/* eslint-disable sort-keys */
const mapStateToProps = createStructuredSelector({
  /**
   * Store: Flex Draft
   */
  confirmationDictionary: selectConfirmationDictionary(),
  infoSectionDictionary: selectInfosectionDictionary(),
  /**
   * Store: Main
   */
  customerServicePhoneNumber: getMainClientInfo('customerServicePhoneNumber'),
  isMurabahaAccount: selectIsMurabahaAccount(),
  scheduleFormValues: selectForm('scheduleSelect'),
});

const mapDispatchToProps = (dispatch) => ({
  /**
   * Store: Flex Draft
   */
  dispatchResetConfirmation: () => dispatch(resetConfirmation()),
  dispatchSetIsModalOpen: (payload) => dispatch(setIsModalOpen(payload)),
});

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default withConnect(Confirmation);
